import { render, staticRenderFns } from "./donor.vue?vue&type=template&id=9650ddfe"
import script from "./donor.vue?vue&type=script&lang=js"
export * from "./donor.vue?vue&type=script&lang=js"
import style0 from "./donor.vue?vue&type=style&index=0&id=9650ddfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports